import { createEffect, onMount, onCleanup, createSignal } from 'solid-js';
import { ComponentDefinition, FormDocument } from '@formbird/types';
import $ from 'jquery';
import 'datatables.net-dt';
import 'datatables.net-dt/css/jquery.dataTables.css';

interface DatatablesProps {
  fieldValue?: any[];
  componentDefinition?: ComponentDefinition;
  document?: FormDocument;
  label?: string;
  mandatory?: boolean;
  enabled?: boolean;
}

export const Datatables = (props: DatatablesProps) => {
  let tableRef: HTMLTableElement | undefined;
  let dataTable: any;

  const [data, setData] = createSignal<any[]>(props.fieldValue || []);

  const componentDef = () => props.componentDefinition;

  onMount(() => {
    if (tableRef) {
      const def = componentDef() as any;
      const columns = def?.gridColumns?.map((col: any) => ({
        title: col.displayName || col.field,
        data: col.field,
        visible: col.visible !== false,
        width: col.width
      })) || [];

      // If no columns defined, try to infer from data or show empty
      if (columns.length === 0 && data().length > 0) {
        Object.keys(data()[0]).forEach(key => {
            if (key !== 'documentId' && key !== 'systemHeader') {
                columns.push({ title: key, data: key });
            }
        });
      }

      dataTable = ($(tableRef) as any).DataTable({
        data: data(),
        columns: columns,
        paging: true,
        searching: true,
        info: true,
        lengthMenu: def?.lengthMenu || [10, 25, 50, 100],
        pageLength: def?.rowsPerPage || 10,
        destroy: true // Allow re-initialization
      });
    }
  });

  createEffect(() => {
    const newData = props.fieldValue;
    if (newData && dataTable) {
        setData(newData);
        dataTable.clear();
        dataTable.rows.add(newData);
        dataTable.draw();
    }
  });

  onCleanup(() => {
    if (dataTable) {
      dataTable.destroy();
    }
  });

  return (
    <div class="p-4">
      {props.label && (
        <label class={`block text-sm font-medium mb-2 ${props.mandatory ? 'text-red-500' : 'text-gray-700'}`}>
          {props.label} {props.mandatory && '*'}
        </label>
      )}
      <div class="overflow-x-auto">
        <table ref={tableRef} class="display" style="width:100%">
        </table>
      </div>
    </div>
  );
};
